import React, { useEffect, useState } from 'react';
import {
    IconPasswordChange,
    UserPasswordDataForm,
    defaultIconPasswordChange
} from '../../../../app/models/User';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';

import useRut from '../../../../hooks/useRut';
import InputField from '../../../../components/InputField/InputField';

interface GeneralUserProps {
    userForm: UserPasswordDataForm;
    setUserForm: (user: UserPasswordDataForm) => void;
    errorFields?: any;
    isProfile?: boolean;
}

const UserPasswordForm = ({
    userForm,
    setUserForm,
    errorFields,
    isProfile = false
}: GeneralUserProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    const [eyeIconOldPassword, setEyeIconOldPassword] =
        useState<IconPasswordChange>(defaultIconPasswordChange);
    const [eyeIconPassword, setEyeIconPassword] =
        useState<IconPasswordChange>(defaultIconPasswordChange);
    const [eyeIconRepeatPassword, setEyeIconRepeatPassword] =
        useState<IconPasswordChange>(defaultIconPasswordChange);

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type } = event.target;
        setUserForm({ ...userForm, [name]: value });
    };

    const setIconValues = (
        eyeIconOldField: IconPasswordChange,
        setEyeIconOldField: React.Dispatch<React.SetStateAction<IconPasswordChange>>
    ) => {
        if (eyeIconOldField.type == 'password') {
            setEyeIconOldField({ ...eyeIconOldField, type: 'text', value: false });
        } else {
            setEyeIconOldField({ ...eyeIconOldField, type: 'password', value: true });
        }
    };

    const changeIconEye = (field: string) => {
        if (field == 'old_password') {
            setIconValues(eyeIconOldPassword, setEyeIconOldPassword);
        } else if (field == 'password') {
            setIconValues(eyeIconPassword, setEyeIconPassword);
        } else {
            setIconValues(eyeIconRepeatPassword, setEyeIconRepeatPassword);
        }
    };

    if (!userForm) return null;

    return (
        <>
            {isProfile && (
                <div className="mb-2 row">
                    <div className="col-md-12">
                        <InputField
                            type={eyeIconOldPassword.type as 'text' | 'password'}
                            label="Contraseña actual"
                            value={userForm.old_password || ''}
                            onChange={(value) => {
                                setUserForm({ ...userForm, old_password: value });
                                onFocusRemove('old_password');
                            }}
                            onFocus={() => onFocusRemove('old_password')}
                            placeholder="Ingrese contraseña actual"
                            error={fieldErrorMessage('old_password')}
                            icon={eyeIconOldPassword.value ? 'fa-eye-slash' : 'fa-eye'}
                        />
                    </div>
                </div>
            )}
            <div className="mb-2 row">
                <div className="col-md-12">
                    <InputField
                        type={eyeIconPassword.type as 'text' | 'password'}
                        label="Nueva Contraseña"
                        value={userForm.password || ''}
                        onChange={(value) => {
                            setUserForm({ ...userForm, password: value });
                            onFocusRemove('password');
                        }}
                        onFocus={() => onFocusRemove('password')}
                        placeholder="Ingrese contraseña nueva"
                        error={fieldErrorMessage('password')}
                        icon={eyeIconPassword.value ? 'fa-eye-slash' : 'fa-eye'}
                    />
                </div>
            </div>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <InputField
                        type={eyeIconRepeatPassword.type as 'text' | 'password'}
                        label="Repetir contraseña"
                        value={userForm.repeat_password || ''}
                        onChange={(value) => {
                            setUserForm({ ...userForm, repeat_password: value });
                            onFocusRemove('repeat_password');
                        }}
                        onFocus={() => onFocusRemove('repeat_password')}
                        placeholder="Repetir contraseña nueva"
                        error={fieldErrorMessage('repeat_password')}
                        icon={eyeIconRepeatPassword.value ? 'fa-eye-slash' : 'fa-eye'}
                    />
                </div>
            </div>
        </>
    );
};

export default UserPasswordForm;
